import React, { PropsWithChildren } from "react";

import "./orientation-blocker-content.css";

export const OrientationBlockerContent = ({ children }: PropsWithChildren) => (
	<>
		<div className="orientation-blocker-content-scrim" />
		<div className="orientation-blocker-content">{children}</div>
	</>
);
OrientationBlockerContent.displayName = "OrientationBlockerContent";
